import { render, staticRenderFns } from "./ContactPhone.vue?vue&type=template&id=601ad47e&"
import script from "./ContactPhone.vue?vue&type=script&lang=js&"
export * from "./ContactPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports